<template>
  <div
    class="question-container"
    :class="[
      content.onlyContent ? 'question-container-clear' : '',
      device.isMobile ? 'question-container-mobile' : '',
      content.noPadding ? 'question-container-no-padding' : '',
    ]"
  >
    <ul class="list_content" v-if="content.contentList">
      <li v-for="(item, index) in content.contentList" :key="item.key">
        <span
          :style="{
            color: '#5CA683',
            fontSize: '26rem', 
            fontfamily: 'Calibri',
            fontStyle: 'italic',
            marginRight: '19rem',
          }"
          >{{ index + 1 }}</span
        >
        <template>
            <popover
            :key="item.key + '.1'"
            :content="item"
            v-if="item.ispop"
          ></popover>
          <span v-if="!item.ispop" :style="{
            color: item.textStyle.color,
            fontSize: item.textStyle.fontSize+'rem',
            fontFamily: 'STXihei',
            fontWeight:400,
            marginLeft:'7rem'
          }">{{ item.text }}</span>

        </template>
        <inputComponent :key="item.key+ '.2'"  :content="item"></inputComponent>
      </li>
    </ul>
    <!-- <div class="question-title">{{ content.title }}</div> -->
    <div
      v-for="(questionItem, questionIndex) in topicContent"
      :key="questionItem.key"
      class="question-content"
      ref="rightCont"
      :class="content.refreshSection?'refresh-section'+content.refreshSection:''"
    >
      <audio
        :src="questionItem.audiofile"
        controls
        v-if="questionItem.audiofile"
      ></audio>
      <!-- <div class="right-top">
        <p>
          {{ questionItem.ps_title }}第{{
            questionIndex + 1
          }}题
        </p>
      </div> -->
      <div class="answer-r-b-subjectC">
        <p
          class="question-subinfo"
          v-html="questionItem.topic_sub[0].subinfo"
        ></p>
        <!-- 单选题&判断题start -->
        <div v-if="questionItem.type_id == 1 || questionItem.type_id == 7">
          <!-- <p
            v-html="questionItem.topic_sub[0].subinfo"
            style="margin-bottom: 12rem"
          ></p> -->
          <el-radio-group
            v-model="questionItem.topic_sub[0].user_answer"
            @change="$forceUpdate()"
          >
            <el-radio
              :label="item.answer_id"
              v-for="(item, index) in questionItem.topic_sub[0].topic_answer"
              :key="index"
              ><span v-html="item.ask"></span
            ></el-radio>
          </el-radio-group>
        </div>
        <!-- 单选题&判断题 end -->
        <!-- 多选题&不定项选择题 start -->
        <div v-if="questionItem.type_id == 2 || questionItem.type_id == 8">
          <!-- <p
            v-html="questionItem.topic_sub[0].subinfo"
            style="margin-bottom: 12rem"
          ></p> -->
          <el-checkbox-group
            v-model="questionItem.topic_sub[0].user_answer"
            @change="$forceUpdate()"
          >
            <div
              v-for="(item, index) in questionItem.topic_sub[0].topic_answer"
              :key="index"
            >
              <el-checkbox :label="item.answer_id">
                <span v-html="item.ask"></span>
              </el-checkbox>
              <div class="other-box" v-if="item.is_other == 1">
                <el-input
                  type="textarea"
                  :rows="6"
                  maxlength="500"
                  show-word-limit
                  placeholder="请输入更多内容"
                  v-model="questionItem.topic_sub[0].other_answer"
                  @input="$forceUpdate()"
                ></el-input>
              </div>
            </div>
          </el-checkbox-group>
        </div>
        <!-- 多选题&不定项选择题 end -->
        <!-- 填空题 start -->
        <div v-if="questionItem.type_id == 3" class="flexel">
          <!-- <p
            v-html="questionItem.topic_sub[0].subinfo"
            style="margin-bottom: 12rem"
          ></p> -->
          <div>
            <div
              v-for="(item, index) in questionItem.topic_sub[0].topic_answer"
              :key="index"
              style="display: flex; align-items: center; margin-bottom: 10rem"
            >
              <el-input
                type="textarea"
                :rows="8"
                maxlength="500"
                show-word-limit
                placeholder="请输入答案"
                v-if="item.textRadio == 1"
                v-model="questionItem.topic_sub[0].brief_answer[index + 1]"
                @input="$forceUpdate()"
              ></el-input>
              <div
                v-if="
                  item.textRadio == 0 &&
                  (questionItem.topic_sub[0].answer_img[index + 1] || []).length
                "
                class="fill-img-box"
              >
                <el-image
                  :src="questionItem.topic_sub[0].answer_img[index + 1][0]"
                  :preview-src-list="[
                    questionItem.topic_sub[0].answer_img[index + 1][0],
                  ]"
                  class="avatar"
                ></el-image>
                <i
                  class="el-icon-remove delect-icon-fill"
                  @click="delectFillImgClick(index + 1)"
                ></i>
              </div>
            </div>
          </div>
        </div>
        <!-- 填空题 end -->
        <!-- 简答题 start -->
        <div v-if="questionItem.type_id == 4" :class="questionItem.topic_sub[0].textareaHeightSize === 'big' ? 'textarea-box-big' : ''">
          <!-- <p
            v-html="questionItem.topic_sub[0].subinfo"
            style="margin-bottom: 12rem"
          ></p> -->
          <el-input
            type="textarea"
            :rows="8"
            placeholder="请输入你的答案"
            v-model="questionItem.topic_sub[0].brief_answer[1]"
            maxlength="2000"
            show-word-limit
            
            :ref="content.refreshSection"
            @input="$forceUpdate()"
            :class="questionItem.topic_sub[0].textareaHeightSize === 'big' ? 'textarea-big' : ''"
            
          >
          </el-input>
          <div
            style="display: flex; align-items: center; margin-top: 22rem"
            v-if="questionItem.topic_sub[0].is_upload"
          >
            <div style="display: flex">
              <div
                v-for="(item, index) in questionItem.topic_sub[0].answer_img[1]"
                :key="index"
                style="
                  width: 60rem;
                  height: 60rem;
                  margin-right: 20rem;
                  position: relative;
                "
              >
                <!-- 图片 start -->
                <el-image
                  :src="item"
                  alt=""
                  style="width: 100%; height: 100%"
                  v-if="
                    item.split('.').pop() == 'jpg' ||
                    item.split('.').pop() == 'jpeg' ||
                    item.split('.').pop() == 'gif' ||
                    item.split('.').pop() == 'png'
                  "
                >
                </el-image>
                <!-- 图片 end -->
                <!-- zip start -->
                <img
                  v-if="item.split('.').pop() == 'zip'"
                  class="file-icon"
                  :src="require('@/assets/images/bookContent/question/zip.png')"
                  alt=""
                />
                <!-- zip end -->
                <!-- rar start -->
                <img
                  v-if="item.split('.').pop() == 'rar'"
                  class="file-icon"
                  :src="require('@/assets/images/bookContent/question/rar.png')"
                  alt=""
                />
                <!-- rar end -->
                <!-- mp3 start -->
                <img
                  v-if="
                    item.split('.').pop() == 'mp3' ||
                    item.split('.').pop() == 'MP3'
                  "
                  class="file-icon"
                  :src="require('@/assets/images/bookContent/question/mp3.png')"
                  alt=""
                />

                <!-- mp3 end -->
                <!-- doc start -->
                <img
                  v-if="
                    item.split('.').pop() == 'doc' ||
                    item.split('.').pop() == 'docx'
                  "
                  class="file-icon"
                  :src="require('@/assets/images/bookContent/question/doc.png')"
                  alt=""
                />

                <!-- doc end -->
                <!-- mp4 start -->
                <img
                  v-if="item.split('.').pop() == 'mp4'"
                  class="file-icon"
                  :src="require('@/assets/images/bookContent/question/mp4.png')"
                  alt=""
                />

                <!-- mp4 end -->
                <!-- pdf start -->
                <img
                  v-if="item.split('.').pop() == 'pdf'"
                  class="file-icon"
                  :src="require('@/assets/images/bookContent/question/pdf.png')"
                  alt=""
                />
                <!-- ppt end -->
                <!-- ppt start -->
                <img
                  v-if="
                    item.split('.').pop() == 'ppt' ||
                    item.split('.').pop() == 'pptx'
                  "
                  class="file-icon"
                  :src="require('@/assets/images/bookContent/question/ppt.png')"
                  alt=""
                />

                <!-- ppt end -->
                <!-- xls start -->
                <img
                  v-if="
                    item.split('.').pop() == 'xls' ||
                    item.split('.').pop() == 'xlsx'
                  "
                  class="file-icon"
                  :src="require('@/assets/images/bookContent/question/xls.png')"
                  alt=""
                />

                <!-- xls end -->
                <i
                  class="el-icon-remove delect-icon"
                  @click="delectImgClick(index)"
                ></i>
              </div>
            </div>
            <uploadFiles
              v-show="
                (questionItem.topic_sub[0].answer_img[1] || []).length < 5
              "
              :ref="`upload${questionItem}`"
              :getTokenParams="uploadGetTokenParams"
              :immediateUpload="true"
              :maxSize="15"
              allowedTypes=".jpg,.jpeg,.gif,.png"
              @uploadUrlChange="uploadUrlChange"
              @uploadClose="uploadClose"
            >
              <template v-slot:uploadView>
                <div
                  @click="$refs[`upload${questionItem}`][0].uploadFilesHandle()"
                  style="
                    width: 60rem;
                    height: 60rem;
                    border: 1rem dashed #c0ccda;
                    border-radius: 6rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                  "
                >
                  <i class="el-icon-plus" style="font-size: 28rem"></i>
                </div>
              </template>
            </uploadFiles>
          </div>
          <p class="tips-p" v-if="questionItem.topic_sub[0].is_upload">
            <span>*</span>
            限制单个文件大小不超过15M，文件数量5个以内，支持格式jpg、jpeg、gif、png
          </p>
        </div>
        <!-- 简答题 end -->
        <!-- 选词填空 start -->
        <div v-if="questionItem.type_id == 9">
          <!-- <p
            v-html="questionItem.topic_sub[0].subinfo"
            style="margin-bottom: 12rem"
          ></p> -->
          <div
            v-for="(item, index) in questionItem.topic_sub[0].topic_answer"
            :key="index"
            class="xcflex"
          >
            <div
              class="blank-input"
              @click="textFocus($event, index)"
              :class="xciIndex == index ? 'xcActive' : ''"
              :title="questionItem.topic_sub[0].brief_answer[index + 1]"
            >
              {{ questionItem.topic_sub[0].brief_answer[index + 1] }}
            </div>
          </div>
          <div
            class="bg-question-box"
            v-if="questionItem.topic_sub[0].xciQuestionShow"
          >
            <el-radio-group
              v-model="questionItem.topic_sub[0].brief_answer[temporaryIndex]"
              @input="$forceUpdate()"
              @change="
                questionChange(
                  questionItem.topic_sub[0].brief_answer[temporaryIndex]
                )
              "
            >
              <el-radio
                v-for="(item, index) in questionItem.topic_sub[0].options"
                :key="index"
                :label="item"
                >{{ item }}</el-radio
              >
            </el-radio-group>
          </div>
        </div>
        <!-- 选词填空 end -->
        <!-- 组合题 start -->
        <div v-if="questionItem.type_id == 5">
          <div class="bg-question-box" ref="bgQuestion">
            <p v-html="questionItem.info"></p>
          </div>
          <!-- 小题题目切换区域 start -->
          <ul class="sub-question-tab">
            <li
              v-for="(item, index) in questionItem.topic_sub"
              :key="index"
              :topic-id="questionItem.topic_id"
              :sub-id="item.sub_id"
              class="sub-question-num"
              :ref="'sub' + questionItem.topic_id + '-' + item.sub_id"
              :class="[
                subActiveId == 'sub' + questionItem.topic_id + '-' + item.sub_id
                  ? 'subActive'
                  : '',
              ]"
              @click="subtabClick(questionItem.topic_id, item, index)"
            >
              <span>第{{ index + 1 }}题</span>
            </li>
          </ul>
          <!-- 小题题干区域 start -->
          <div>
            <!-- 单选题&判断题start -->
            <div
              v-if="
                questionItem.topic_sub[subtabIndex].type_id == 1 ||
                questionItem.topic_sub[subtabIndex].type_id == 7
              "
            >
              <p
                v-html="questionItem.topic_sub[subtabIndex].subinfo"
                style="margin-bottom: 12rem"
              ></p>
              <el-radio-group
                v-model="questionItem.topic_sub[subtabIndex].user_answer"
                @change="$forceUpdate()"
              >
                <el-radio
                  :label="item.answer_id"
                  v-for="(item, index) in questionItem.topic_sub[subtabIndex]
                    .topic_answer"
                  :key="index"
                  ><span v-html="item.ask"></span
                ></el-radio>
              </el-radio-group>
            </div>
            <!-- 单选题&判断题 end -->
            <!-- 多选题&不定项选择题 start -->
            <div
              v-if="
                questionItem.topic_sub[subtabIndex].type_id == 2 ||
                questionItem.topic_sub[subtabIndex].type_id == 8
              "
            >
              <p
                v-html="questionItem.topic_sub[subtabIndex].subinfo"
                style="margin-bottom: 12rem"
              ></p>
              <el-checkbox-group
                v-model="questionItem.topic_sub[subtabIndex].user_answer"
                @change="$forceUpdate()"
              >
                <el-checkbox
                  :label="item.answer_id"
                  v-for="(item, index) in questionItem.topic_sub[subtabIndex]
                    .topic_answer"
                  :key="index"
                  ><span v-html="item.ask"></span
                ></el-checkbox>
              </el-checkbox-group>
            </div>
            <!-- 多选题&不定项选择题 end -->
            <!-- 填空题 start -->
            <div
              v-if="questionItem.topic_sub[subtabIndex].type_id == 3"
              class="flexel"
            >
              <p
                v-html="questionItem.topic_sub[subtabIndex].subinfo"
                style="margin-bottom: 12rem"
              ></p>
              <div>
                <div
                  v-for="(item, index) in questionItem.topic_sub[subtabIndex]
                    .topic_answer"
                  :key="index"
                  style="
                    display: flex;
                    align-items: center;
                    margin-bottom: 10rem;
                  "
                >
                  <el-input
                    type="textarea"
                    :rows="8"
                    maxlength="500"
                    show-word-limit
                    placeholder="请输入答案"
                    style="font-size: 16rem"
                    v-if="item.textRadio == 1"
                    v-model="
                      questionItem.topic_sub[subtabIndex].brief_answer[
                        index + 1
                      ]
                    "
                    @input="$forceUpdate()"
                  ></el-input>
                  <div
                    v-if="
                      item.textRadio == 0 &&
                      (
                        questionItem.topic_sub[subtabIndex].answer_img[
                          index + 1
                        ] || []
                      ).length
                    "
                    class="fill-img-box"
                  >
                    <el-image
                      :src="
                        questionItem.topic_sub[subtabIndex].answer_img[
                          index + 1
                        ][0]
                      "
                      :preview-src-list="[
                        questionItem.topic_sub[subtabIndex].answer_img[
                          index + 1
                        ][0],
                      ]"
                      class="avatar"
                    ></el-image>
                    <i
                      class="el-icon-remove delect-icon-fill"
                      @click="delectFillImgClick(index + 1, subtabIndex)"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
            <!-- 填空题 end -->
            <!-- 简答题 start -->
            <div v-if="questionItem.topic_sub[subtabIndex].type_id == 4">
              <p
                v-html="questionItem.topic_sub[subtabIndex].subinfo"
                style="margin-bottom: 12rem"
              ></p>
              <el-input
                type="textarea"
                :rows="12" 
                placeholder="请输入你的答案"
                v-model="questionItem.topic_sub[subtabIndex].brief_answer[1]"
                maxlength="2000"
                :ref="content.refreshSection"
                show-word-limit
                style="font-size: 16rem"
                @input="$forceUpdate()"
                
              >
              </el-input>
              <div
                style="display: flex; align-items: center; margin-top: 22rem"
              >
                <div style="display: flex">
                  <div
                    v-for="(item, index) in questionItem.topic_sub[subtabIndex]
                      .answer_img[1]"
                    :key="index"
                    style="
                      width: 60rem;
                      height: 60rem;
                      margin-right: 20rem;
                      position: relative;
                    "
                  >
                    <!-- 图片 start -->
                    <el-image
                      :src="item"
                      alt=""
                      style="width: 100%; height: 100%"
                      v-if="
                        item.split('.').pop() == 'jpg' ||
                        item.split('.').pop() == 'jpeg' ||
                        item.split('.').pop() == 'gif' ||
                        item.split('.').pop() == 'png'
                      "
                    >
                    </el-image>
                    <!-- 图片 end -->
                    <!-- zip start -->
                    <img
                      v-if="item.split('.').pop() == 'zip'"
                      class="file-icon"
                      :src="
                        require('@/assets/images/bookContent/question/zip.png')
                      "
                      alt=""
                    />

                    <!-- zip end -->
                    <!-- rar start -->
                    <img
                      v-if="item.split('.').pop() == 'rar'"
                      class="file-icon"
                      :src="
                        require('@/assets/images/bookContent/question/rar.png')
                      "
                      alt=""
                    />

                    <!-- rar end -->
                    <!-- mp3 start -->
                    <img
                      v-if="
                        item.split('.').pop() == 'mp3' ||
                        item.split('.').pop() == 'MP3'
                      "
                      class="file-icon"
                      :src="
                        require('@/assets/images/bookContent/question/mp3.png')
                      "
                      alt=""
                    />

                    <!-- mp3 end -->
                    <!-- doc start -->
                    <img
                      v-if="
                        item.split('.').pop() == 'doc' ||
                        item.split('.').pop() == 'docx'
                      "
                      class="file-icon"
                      :src="
                        require('@/assets/images/bookContent/question/doc.png')
                      "
                      alt=""
                    />

                    <!-- doc end -->
                    <!-- mp4 start -->
                    <img
                      v-if="item.split('.').pop() == 'mp4'"
                      class="file-icon"
                      :src="
                        require('@/assets/images/bookContent/question/mp4.png')
                      "
                      alt=""
                    />
                    <!-- mp4 end -->
                    <!-- pdf start -->
                    <img
                      v-if="item.split('.').pop() == 'pdf'"
                      class="file-icon"
                      :src="
                        require('@/assets/images/bookContent/question/pdf.png')
                      "
                      alt=""
                    />

                    <!-- ppt end -->
                    <!-- ppt start -->
                    <img
                      v-if="
                        item.split('.').pop() == 'ppt' ||
                        item.split('.').pop() == 'pptx'
                      "
                      class="file-icon"
                      :src="
                        require('@/assets/images/bookContent/question/ppt.png')
                      "
                      alt=""
                    />
                    <!-- ppt end -->
                    <!-- xls start -->
                    <img
                      v-if="
                        item.split('.').pop() == 'xls' ||
                        item.split('.').pop() == 'xlsx'
                      "
                      class="file-icon"
                      :src="
                        require('@/assets/images/bookContent/question/xls.png')
                      "
                      alt=""
                    />

                    <!-- xls end -->
                    <i
                      class="el-icon-remove delect-icon"
                      @click="delectImgClick(index, subtabIndex)"
                    ></i>
                  </div>
                </div>
                <uploadFiles
                  :ref="`upload${questionItem}`"
                  :maxSize="15"
                  allowedTypes=".jpg,.jpeg,.gif,.png"
                  :getTokenParams="uploadGetTokenParams"
                  :immediateUpload="true"
                  @uploadUrlChange="uploadUrlChange"
                  @uploadClose="uploadClose"
                  v-show="
                    (questionItem.topic_sub[subtabIndex].answer_img[1] || [])
                      .length < 5
                  "
                >
                  <template v-slot:uploadView>
                    <div
                      @click="
                        $refs[`upload${questionItem}`][0].uploadFilesHandle()
                      "
                      style="
                        width: 60rem;
                        height: 60rem;
                        border: 1rem dashed #c0ccda;
                        border-radius: 6rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                      "
                    >
                      <i class="el-icon-plus" style="font-size: 28rem"></i>
                    </div>
                  </template>
                </uploadFiles>
              </div>
              <p class="tips-p">
                <span>*</span>
                限制单个文件大小不超过15M，文件数量5个以内，支持格式jpg、jpeg、gif、png
              </p>
            </div>
            <!-- 简答题 end -->
            <!-- 选词填空题 start -->
            <div v-if="questionItem.topic_sub[subtabIndex].type_id == 9">
              <p
                v-html="questionItem.topic_sub[subtabIndex].subinfo"
                style="margin-bottom: 12rem"
              ></p>
              <div
                v-for="(item, index) in questionItem.topic_sub[subtabIndex]
                  .topic_answer"
                :key="index"
                class="xcflex"
              >
                <div
                  @click="textFocus($event, index, 'zuheti')"
                  :class="xciIndex == index ? 'xcActive' : ''"
                  :title="
                    questionItem.topic_sub[subtabIndex].brief_answer[index + 1]
                  "
                >
                  {{
                    questionItem.topic_sub[subtabIndex].brief_answer[index + 1]
                  }}
                </div>
              </div>
              <div
                class="bg-question-box"
                v-if="questionItem.topic_sub[subtabIndex].xciQuestionShow"
              >
                <el-radio-group
                  v-model="
                    questionItem.topic_sub[subtabIndex].brief_answer[
                      temporaryIndex
                    ]
                  "
                  @input="$forceUpdate()"
                  @change="
                    questionChange(
                      questionItem.topic_sub[subtabIndex].brief_answer[
                        temporaryIndex
                      ],
                      'zuheti'
                    )
                  "
                >
                  <el-radio
                    v-for="(item, index) in questionItem.topic_sub[subtabIndex]
                      .options"
                    :key="index"
                    :label="item"
                    >{{ item }}</el-radio
                  >
                </el-radio-group>
              </div>
            </div>
            <!-- 选词填空题 end -->
          </div>
          <!-- 小题题干区域 start -->
          <!-- 小题题目切换区域 end -->
        </div>
        <!-- 组合题 end -->
        <!-- 操作题 start -->
        <div v-if="questionItem.type_id == 6">
          <!-- <p
            v-html="questionItem.topic_sub[0].subinfo"
            style="margin-bottom: 12rem"
          ></p> -->
        </div>
        <!-- 操作题 end -->
        <!-- 交互题 start -->
        <div v-if="questionItem.type_id == 10">
          <!-- <p
            v-html="questionItem.topic_sub[0].subinfo"
            style="margin-bottom: 12rem"
          ></p> -->
          <actionIndex
            :content="questionItem.topic_sub[0].topic_content"
            @updateAnswer="actionUpdateAnswer($event, questionIndex)"
          ></actionIndex>
        </div>
        <!-- 交互题 end -->
      </div>
      <div class="right-bottom" v-if="topicShowType === 'one'">
        <div>
          <span
            class="pre-btn switch-btn"
            @mouseover="preHover = true"
            @mouseleave="preHover = false"
            @click="backClick()"
            :style="{
              backgroundColor: preHover ? '#0FC29A' : '#fff',
              color: preHover ? '#fff' : '#0FC29A',
            }"
            :class="currentNum == 1 ? 'backDisabled' : ''"
            >上一题</span
          ><span
            class="next-btn switch-btn"
            @mouseover="nextHover = true"
            @mouseleave="nextHover = false"
            @click="nextClick()"
            :style="{
              backgroundColor: nextHover ? '#0FC29A' : '#fff',
              color: nextHover ? '#fff' : '#0FC29A',
            }"
            :class="currentNum == totalLength ? 'backDisabled' : ''"
            >下一题</span
          >
        </div>

        <!-- <img
          class="submit"
          :src="submitImgDefault"
          alt=""
          @mouseover="changeImageOnHover(true)"
          @mouseout="changeImageOnHover(false)"
          @click="submitClick"
        /> -->
        <!-- <div v-if="!queryParams.pid">
          <span
            class="sign-btn"
            @click="signAnserClick"
            :class="[currentSignType ? 'sign-active-btn' : '']"
            >{{ currentSignType ? "取消标记" : "标记" }}</span
          >
        </div> -->
      </div>
    </div>
    <div
      class="question-bottom"
      :style="{
        width: (content.submitBtnStyle || {}).width + 'rem' || '',
        height: (content.submitBtnStyle || {}).height + 'rem' || '',
        lineHeight: (content.submitBtnStyle || {}).lineHeight + 'rem' || '',
        backgroundColor: (content.submitBtnStyle || {}).backgroundColor || '',
      }"
      @click.stop="submitAnswer"
    >
      提交
    </div>
    <commonPopup
      :dialogVisible="statisticsVisible"
      dialogTitle="统计结果"
      dialogType="statistics"
      @dialogClose="statisticsClose"
    ></commonPopup>
  </div>
</template>
<script>
/*
答题组件
*/
import { createTopicMX } from "./answerdoing.js";
import commonPopup from "../popup/common.vue";
import actionIndex from "../action/index.vue";
import { throttle } from "lodash";
import popover from "../text/popover.vue";
import inputComponent from "../text/input.vue";
export default {
  mixins: [createTopicMX],
  name: "questionIndex",
  components: {
    commonPopup,
    actionIndex,
    popover,
    inputComponent
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  inject:['resetTo'],
  data() {
    return {
      topicContent: [],
      statisticsVisible: false,
      topicShowType: "all", // 题目展示方式 all：全部展示 one：单个展示
    };
  },
  created(){
    
  },
  mounted() {
    if (this.topicShowType === "all") {
      this.topicContent = this.content.content;
    } else {
      this.topicContent = [this.content.content[0]];
    }
    this.$bus.$on('resetsss',(data)=>{
    if(this.content.refreshSection==data){
      for(var i=0;i<this.topicContent.length;i++){
        for(var j=0;j<this.topicContent[i].topic_sub[0].topic_answer.length;j++){
          this.topicContent[i].topic_sub[0].brief_answer[j+1]=''
        }
      }
    }
    })
  },
  methods: {
    
    submitAnswer: throttle(function () {
      if(this.content.contentList){
        this.$message.success("提交成功！");
        return;
      }
      this.paperList = this.content.content;
      for (let i = 0; i < this.content.content.length; i++) {
        if (this.content.content[i].topic_sub[0].type_id === 4) {
          if (!this.content.content[i].topic_sub[0].brief_answer["1"]) {
            this.$message.error(`请完成第${i + 1}题`);
            return;
          }
        } else if (this.content.content[i].topic_sub[0].type_id === 2) {
          if (this.content.content[i].topic_sub[0].user_answer.length === 0) {
            this.$message.error(`请完成第${i + 1}题`);
            return;
          }
          let topic_answer = this.content.content[i].topic_sub[0].topic_answer;
          if (topic_answer[topic_answer.length - 1].is_other === 1) {
            if (
              this.content.content[i].topic_sub[0].user_answer.indexOf(
                topic_answer[topic_answer.length - 1].answer_id
              ) > -1
            ) {
              if (!this.content.content[i].topic_sub[0].other_answer) {
                this.$message.error(`请完成第${i + 1}题`);
                return;
              }
            }
          }
        } else {
          if (this.content.content[i].topic_sub[0].user_answer.length === 0) {
            this.$message.error(`请完成第${i + 1}题`);
            return;
          }
        }
      }
      if (this.content.completeType === "statistics") {
        this.statisticsVisible = true;
      } else {
        this.$message.success("提交成功！");
      }
    }, 1000),
    actionUpdateAnswer(e, index) {
      if (e.indexOf("") === -1) {
        this.content.content[index].topic_sub[0].user_answer = e;
      }
    },
    statisticsClose() {
      this.statisticsVisible = false;
    },
    fillChange(val, index, pindex) {
      this.$forceUpdate();
      var indexs = index + 1;
      if (pindex != undefined) {
        if (val == 1) {
          this.questionItem.topic_sub[pindex].answer_img[index + 1] = [];
        } else {
          this.questionItem.topic_sub[pindex].user_answer[index + 1] = "";
        }
        this.questionItem.topic_sub[pindex].topic_answer[index].textRadio = val;
      } else {
        if (val == 1) {
          this.questionItem.topic_sub[0].answer_img[index + 1] = [];
        } else {
          this.questionItem.topic_sub[0].user_answer[index + 1] = "";
        }
        this.questionItem.topic_sub[0].topic_answer[index].textRadio = val;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.question-container {
  width: calc(100% - 48rem);
  margin: 95rem auto 20rem;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0rem 3rem 16rem 0rem rgba(32, 37, 36, 0.1);
  border-radius: 10rem;
  border: 1rem solid #4b96d1;
  position: relative;
  padding: 40rem 30rem 60rem;
  box-sizing: border-box;
  font-family: "宋体";
  font-weight: bold;

  &:before {
    content: "";
    display: block;
    width: 196rem;
    height: 56rem;
    position: absolute;
    left: 0;
    top: -50rem;
    background: url("~@/assets/images/books/bookExample/question-icon.png")
      center center no-repeat;
    background-size: contain;
  }

  .question-content {
    flex: 1;
    margin-bottom: 30rem;

    .answer-r-b-subjectC {
      .question-subinfo {
        margin-bottom: 20rem;
        font-size: 18rem;
        color: #333;
      }

      > div {
        padding-left: 24rem;
      }
      
      .textarea-box-big{
        padding-left: 0;
      }

      .other-box {
        padding-left: 32rem;

        /deep/.el-textarea__inner {
          height: 120rem;
        }
      }
    }
    .answer-r-b-subjectT {
      display: flex;
      align-items: center;

      p {
        font-weight: bold;
        margin-left: 10rem;
      }
      span {
        color: #9c9c9c;
        font-size: 18rem;
      }
    }
  }

  .right-bottom {
    height: 105rem;
    box-shadow: 0rem 4rem 14rem 0rem rgba(154, 154, 162, 0.39);
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 25rem;
    span {
      width: 154rem;
      height: 48rem;
      line-height: 48rem;
      display: inline-block;
      text-align: center;
      font-size: 19rem;
      cursor: pointer;
    }
    .switch-btn {
      border: 1rem solid #0fc29a;
      color: #0fc29a;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
    .next-btn {
      margin-left: 12rem;
    }
    .sign-btn {
      background: #ff733c;
      border: 1rem solid #ff733c;
      color: #fff;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
    .sign-active-btn {
      background: #c36c4a;
      border: 1rem solid #c36c4a;
    }

    .submit {
      width: 119rem;
      height: 70rem;
      z-index: 1;
      cursor: pointer;
    }
  }

  .question-bottom {
    width: 180rem;
    height: 48rem;
    line-height: 48rem;
    background: #f48450;
    color: #fff;
    font-size: 18rem;
    text-align: center;
    border-radius: 4rem;
    margin: 20rem auto 0;
    cursor: pointer;
  }
}

.question-container-clear {
  width: 100%;
  margin: 0;
  background: transparent;
  box-shadow: none;
  border: 0;
  padding: 0 20rem 30rem;

  &:before {
    display: none;
  }
}
.question-container-no-padding{
  padding: 0 0 30rem;
}
/deep/.el-radio {
  // display: block !important;
  display: flex;
  margin-bottom: 12rem !important;
  font-size: 15rem !important;
  display: flex;
  align-items: center;
  font-weight: bold;
  .el-radio__label {
    color: #333;
    span {
      font-size: 18rem;
    }
  }
}
/deep/.el-radio__inner {
  width: 16rem !important;
  height: 16rem !important;
}
/deep/.el-checkbox {
  margin-bottom: 20rem !important;
  display: flex;
  align-content: center;
  font-weight: bold;
  .el-checkbox__label {
    line-height: 24rem;
    width: calc(100% - 24rem);
    color: #333;
    span {
      font-size: 18rem;
    }
  }
}
/deep/.el-checkbox__input {
  display: flex;
  align-items: center;
}
/deep/.el-checkbox__inner {
  width: 16rem;
  height: 16rem;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner {
  background: #f48450 !important;
  border-color: #f48450 !important;
}

/deep/.el-checkbox__inner:hover,
/deep/.el-checkbox__input.is-focus,
/deep/.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #f48450 !important;
}
/deep/.el-radio__input.is-checked + .el-radio__label,
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #f48450;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  background: #f48450 !important;
  border-color: #f48450 !important;
}
/deep/.el-checkbox__inner::after {
  height: 8rem;
  left: 6rem;
}
/deep/.flexel .el-radio {
  display: inline !important;
}
/deep/.flexel .el-input__inner {
  margin-right: 10rem !important;
  border: none;
  border-radius: 0;
  border-bottom: 1rem solid #222;
}
.avatar-uploader {
  width: 30rem;
  height: 30rem;
  line-height: 30rem;
  text-align: center;
  border: 1rem dashed #aaa;
  margin-right: 10rem;
}
/deep/.el-upload--picture-card {
  width: 60rem;
  height: 60rem;
  position: relative;
  // margin-top:12rem;
}
/deep/.el-upload--picture-card:hover {
  border: 1rem dashed #12c37c;
}
/deep/.el-upload--picture-card .el-icon-plus {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/deep/.el-textarea {
  font-size: 16rem;
  color: #333;
  .el-input__count {
    bottom: -24px;
    font-family: "Times New Roman";
  }
}
/deep/.el-textarea__inner {
  height: 140rem;
  font-family: "宋体";
  font-size: 18rem;
  color: #333;
  font-weight: bold;
}

/deep/.el-textarea.textarea-big{
  .el-textarea__inner{
    height: 300rem;
  }
}
/deep/.el-textarea__inner:focus {
  border: 1rem solid #dcdfe6;
}
.tips-p {
  color: #aeaeae;
  font-size: 13rem;
  margin-top: 10rem;
  span {
    color: #ff0000;
  }
}
.sub-question-tab {
  width: 100%;
  height: auto;
  margin-bottom: 10rem;
  padding: 20rem 10rem 10rem;
  text-align: left;
  border: 1rem solid #edf0f2;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  display: flex;
  // position: relative;
}
.sub-question-num {
  padding-bottom: 6rem;
  margin: 0 15rem 10rem 0;
  cursor: pointer;
  height: 38rem;
  position: relative;
}

.sub-question-num span {
  display: inline-block;
  width: 90rem;
  height: 32rem;
  color: #888;
  line-height: 32rem;
  background: #edf0f2;
  text-align: center;
  border-radius: 4rem;
  overflow: hidden;
}
/deep/.subActive span {
  height: 38rem;
  color: #fff;
  background: url("~@/assets/images/bookContent/question/small-topic-active-bg.png")
    center no-repeat;
}

/deep/.flexel .el-radio {
  display: inline !important;
}
/deep/.flexel .el-input__inner {
  margin-right: 10rem !important;
  border: none;
  border-radius: 0;
  border-bottom: 1rem solid #222;
}

.question-container-mobile {
  .question-content {
    margin-bottom: 50rem;
    .answer-r-b-subjectC {
      .question-subinfo {
        font-size: 26rem;
      }

      .other-box {
        /deep/.el-textarea__inner {
          height: 200rem;
        }
      }
    }
  }

  .question-bottom {
    width: 180rem;
    height: 52rem;
    line-height: 52rem;
    font-size: 26rem;
    border-radius: 6rem;
    margin: 40rem auto 0;
  }

  /deep/.el-checkbox {
    .el-checkbox__input {
      .el-checkbox__inner {
        width: 22rem;
        height: 22rem;
      }
    }
    .el-checkbox__label {
      color: #333;
      span {
        font-size: 26rem;
      }
    }
  }

  /deep/.el-textarea {
    .el-textarea__inner {
      height: 240rem;
      font-size: 26rem;
    }
  }
  /deep/.el-textarea.textarea-big{
    .el-textarea__inner{
      height: 500rem;
    }
  }
  
  /deep/.el-radio {
    font-size: 22rem !important;
    .el-radio__label {
      span {
        font-size: 26rem;
      }
    }
  }
  /deep/.el-radio__inner {
    width: 22rem !important;
    height: 22rem !important;
  }
}

.list_content li {
}
.input_val{
  display: inline-block;
  width:440rem;
  float: right;
  /deep/.el-input__inner{
  border:none;
  border-radius: 0;
    border-bottom:1rem solid #999999;
    font-size:18rem;
    color:#333;
  }
}
</style>